<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_isfahan-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_isfahan-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.825;"
  >
    <div
      id="g-p3_isfahan-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_isfahan-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.0203%;margin-top:-11.1px;left:0.0001%;width:184px;"
    >
      <p class="g-pstyle0">Isfahan enrichment facility</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.1245%;margin-top:-7.5px;left:14.2349%;width:59px;"
    >
      <p class="g-pstyle1">Isfahan</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:20.1245%;margin-top:-7.5px;left:19.5511%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.3745%;margin-top:-7.5px;left:26.0127%;width:119px;"
    >
      <p class="g-pstyle3">Structure damaged</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:41.6245%;margin-top:-6.5px;left:22.9887%;width:120px;"
    >
      <p class="g-pstyle4">Structure destroyed</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_isfahan-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.83333333333333;"
  >
    <div
      id="g-p3_isfahan-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_isfahan-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.4974%;margin-top:-11.2px;left:0.0001%;width:207px;"
    >
      <p class="g-pstyle0">Isfahan enrichment facility</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.0095%;margin-top:-7.5px;left:10.1135%;width:59px;"
    >
      <p class="g-pstyle1">Isfahan</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.4605%;margin-top:-7.5px;left:13.2972%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:28.6762%;margin-top:-7.5px;left:20.8604%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle3">Structure damaged</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:41.2905%;margin-top:-14.7px;left:22.6857%;width:71px;"
    >
      <p class="g-pstyle4">Structure</p>
      <p class="g-pstyle4">destroyed</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_isfahan-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.825;"
  >
    <div
      id="g-p3_isfahan-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_isfahan-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.6662%;margin-top:-11.3px;left:0%;width:253px;"
    >
      <p class="g-pstyle0">Isfahan enrichment facility</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.7601%;margin-top:-9.1px;left:10.1348%;width:65px;"
    >
      <p class="g-pstyle1">Isfahan</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.2601%;margin-top:-9.1px;left:13.3496%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:29.3851%;margin-top:-9.1px;left:20.8919%;margin-left:-67.5px;width:135px;"
    >
      <p class="g-pstyle3">Structure damaged</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:41.8101%;margin-top:-17.5px;left:22.7336%;width:79px;"
    >
      <p class="g-pstyle4">Structure</p>
      <p class="g-pstyle4">destroyed</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 21:07 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 21:07 -->
<!-- ai file: p3_isfahan.ai -->
<style lang="scss">
  #g-p3_isfahan-box,
  #g-p3_isfahan-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_isfahan-box p {
    margin: 0;
  }
  #g-p3_isfahan-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_isfahan-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_isfahan-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_isfahan-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_isfahan-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_isfahan-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-p3_isfahan-md {
        display: block !important;
      }
    }
  }
  #g-p3_isfahan-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_isfahan-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_isfahan-xs .g-pstyle0 {
    height: 21px;
  }
  #g-p3_isfahan-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_isfahan-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_isfahan-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-p3_isfahan-xs .g-pstyle4 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-p3_isfahan-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_isfahan-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_isfahan-sm .g-pstyle0 {
    height: 21px;
  }
  #g-p3_isfahan-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_isfahan-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_isfahan-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_isfahan-sm .g-pstyle4 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-p3_isfahan-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_isfahan-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 20px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_isfahan-md .g-pstyle0 {
    height: 21px;
  }
  #g-p3_isfahan-md .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-p3_isfahan-md .g-pstyle2 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_isfahan-md .g-pstyle3 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_isfahan-md .g-pstyle4 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
